import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ResultService {
  public formPromise: Observable<any>;
  public formRequest: Observable<any>;
  constructor() { }
}
